import qs from 'querystring';
import {PAYMENT_SESSION_ID_LENGTH} from '../consts';

export const getPaymentSessionId = (params, query) =>
    (params?.sessionId || query.paymentSessionId).slice(0, PAYMENT_SESSION_ID_LENGTH);

export function redirectPost(location, args) {
    const form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', location);

    args.forEach(arg => {
        const field = document.createElement('input');

        field.setAttribute('type', 'hidden');
        field.setAttribute('name', arg.name);
        field.setAttribute('value', arg.value);

        return form.appendChild(field);
    });

    document.body.appendChild(form);
    form.submit();
}


export function redirectTo(url, {method = 'GET', parameters} = {}) {
    let redirectUrl = url;

    // GET method
    if (method && method.toLowerCase() === 'get') {
        if (parameters) {
            redirectUrl = `${redirectUrl}?${qs.stringify(parameters)}`;
        }

        if (typeof window !== 'undefined') {
            window.location.replace(redirectUrl);
        }

        return redirectUrl;
    }

    // POST method
    return redirectPost(url, parameters);
}

export function getYearsFromNow(n = 19) {
    const currentYear = new Date().getFullYear();
    const years = Array.from({length: n + 1}).map((_, i) => `${currentYear + i}`);

    return years;
}

const WEB_RELAUNCH_COOKIE_KEY = 'Eg9be';
const WEB_RELAUNCH_COOKIE_TRUTHY_VALUE = '1';

export const isWebRelaunchStyleCookieOn = cookies =>
    cookies[WEB_RELAUNCH_COOKIE_KEY] === WEB_RELAUNCH_COOKIE_TRUTHY_VALUE;

export const handleEnterKey = handler => e => {
    if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        handler(e);
    }
};
